"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  if (a != null && typeof a === 'object' && b != null && typeof b === 'object') {
    for (var key in a) {
      if (Object.prototype.hasOwnProperty.call(a, key)) {
        if (!Object.prototype.hasOwnProperty.call(b, key)) {
          return false;
        }

        if (!isEqual(a[key], b[key])) {
          return false;
        }
      }
    }

    for (var key in b) {
      if (!Object.prototype.hasOwnProperty.call(a, key)) {
        return false;
      }
    }

    return true;
  }

  return false;
}

exports.isEqual = isEqual;